import React from 'react';
import { fade, makeStyles } from '@material-ui/core';
import { colors } from '@lifesize/clients.mui-components';

const LoadingAnimation = () => {
  const classes = useStyles();
  return (
    <div className={classes.animation}>
      <span />
      <span />
    </div>
  );
};

const useStyles = makeStyles(() => ({
  '@keyframes pulseRing': {
    '0%': {
      transform: 'scale(0.33)'
    },
    '80%, 100%': {
      opacity: 0
    }
  },

  '@keyframes pulseDot': {
    '0%': {
      transform: 'scale(0.8)'
    },
    '50%': {
      transform: 'scale(1)'
    },
    '100%': {
      transform: 'scale(0.8)'
    }
  },

  animation: {
    width: 30,
    height: 30,
    position: 'absolute',
    top: '50%',
    left: '44.5%',
    '& span:first-child': {
      position: 'relative',
      display: 'block',
      width: '300%',
      height: '300%',
      boxSizing: 'border-box',
      marginLeft: '-100%',
      marginTop: '-100%',
      borderRadius: 45,
      backgroundColor: colors.lifesize,
      animation: '$pulseRing 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite'
    },

    '& span:nth-child(2)': {
      position: 'absolute',
      left: 0,
      top: 0,
      display: 'block',
      width: '100%',
      height: '100%',
      backgroundColor: colors.lifesize,
      borderRadius: 15,
      boxShadow: `0 0 8px ${fade(colors.black, 0.3)}`,
      animation: '$pulseDot 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite'
    }
  }
}));

export default LoadingAnimation;
